import apiClient from './api';

export const authService = {
  sendMagicLink: async (email) => {
    const response = await apiClient.post('/api/auth/merchant/login', { email });
    return response.data;
  },

  authenticate: async (token, tokenType) => {
    const response = await apiClient.post('/api/auth/merchant/authenticate', {
      token,
      token_type: tokenType
    });
    return response.data;
  },

  getProfile: async () => {
    const response = await apiClient.get('/api/auth/merchant/profile');
    return response.data;
  },

  logout: async () => {
    const response = await apiClient.post('/api/auth/merchant/logout');
    return response.data;
  }
};

export const dashboardService = {
  getStats: async () => {
    const response = await apiClient.get('/api/dashboard/stats');
    return response.data;
  },

  getProducts: async (limit = 20, skip = 0) => {
    const response = await apiClient.get('/api/dashboard/products', {
      params: { limit, skip }
    });
    return response.data;
  },

  createProduct: async (productData) => {
    const response = await apiClient.post('/api/dashboard/products', productData);
    return response.data;
  },

  createDeal: async (dealData) => {
    const response = await apiClient.post('/api/dashboard/deals', dealData);
    return response.data;
  },

  updateDeal: async (dealId, dealData) => {
    const response = await apiClient.put(`/api/dashboard/deals/${dealId}`, dealData);
    return response.data;
  },

  setDealStatus: async (dealId, status) => {
    const response = await apiClient.post(`/api/dashboard/deals/${dealId}/status`, { status });
    return response.data;
  },

  getChartData: async () => {
    const response = await apiClient.get('/api/dashboard/analytics/chart-data');
    return response.data;
  },

  getDistributionChannels: async () => {
    const response = await apiClient.get('/api/dashboard/distribution/channels');
    return response.data;
  },

  getDealsPerformance: async (timeRange = '30d') => {
    const response = await apiClient.get('/api/merchant/analytics/deals/performance', {
      params: { time_range: timeRange }
    });
    return response.data;
  },

  getDeals: async (limit = 100, skip = 0) => {
    const response = await apiClient.get('/api/dashboard/deals', {
      params: { limit, skip }
    });
    return response.data;
  },

  // AI Recommendations
  getRecommendations: async (limit = 10) => {
    const response = await apiClient.get('/api/merchant/intelligence/recommendations', {
      params: { limit }
    });
    return response.data;
  },
};
